export const downloadTypes = Object.freeze({
  picture: 'picture',
  excel: 'excel'
})
